import React from "react";
import { useNavigate } from "react-router-dom";
import "./Unauthorized.css"; // Import CSS for styling

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="unauthorized-icon" aria-hidden>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <h1 className="unauthorized-title">Unauthorized Access</h1>
        <p className="unauthorized-text">
          You do not have the necessary permissions to view this page.
        </p>
        <button className="unauthorized-button" onClick={handleGoBack}>
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
